import React from 'react'
import GripTumbler from '@components/brand/grip-tumbler'

import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const GripTumblerPage = () => {
  return <GripTumbler />
}
export default GripTumblerPage
